import React from "react";
import { Box, Grid, Typography, Divider, List, ListItem, ListItemText, Paper } from "@mui/material";

const Resume32 = ({
  color = "#27ae60", // Professional Green theme (you can change this to any color)
  font = "Montserrat, sans-serif",
  fontSize = "14px",
  headingSize = "20px"
}) => {
  return (
    <Box sx={{ 
      width: "210mm", 
      minHeight: "297mm", 
      mx: "auto", 
      bgcolor: "#fff", 
      fontFamily: font,
      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
      borderTop: `15px solid ${color}` // Highlighted Top Border
    }}>
      {/* Header Section */}
      <Box sx={{ p: 5, pb: 2, textAlign: "center" }}>
        <Typography variant="h3" sx={{ fontWeight: "800", color: "#333", letterSpacing: 1 }}>
          RICHARD SANCHEZ
        </Typography>
        <Typography variant="h6" sx={{ color: color, fontWeight: "600", letterSpacing: 3, mb: 2 }}>
          MARKETING MANAGER
        </Typography>
        
        <Grid container justifyContent="center" spacing={3} sx={{ color: "#666", fontSize: "13px" }}>
          <Grid item>📞 +123-456-7890</Grid>
          <Grid item>✉️ hello@reallygreatsite.com</Grid>
          <Grid item>📍 Any City, State</Grid>
        </Grid>
      </Box>

      <Divider sx={{ mx: 5, my: 2 }} />

      <Grid container sx={{ px: 5, py: 2 }} spacing={4}>
        {/* Left Column (Main Details) */}
        <Grid item xs={7} sx={{width:"350px"}}>
          <Box sx={{ mb: 4 }}>
            <Typography sx={{ fontSize: headingSize, fontWeight: "bold", color: color, mb: 1.5 }}>
              ABOUT ME
            </Typography>
            <Typography sx={{ fontSize: fontSize, color: "#444", lineHeight: 1.6, textAlign: "justify" }}>
              Dynamic and result-oriented Marketing Manager with 8+ years of experience. Proven expertise in 
              market analysis, digital growth, and campaign management. Committed to driving brand 
              innovation and achieving organizational targets.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography sx={{ fontSize: headingSize, fontWeight: "bold", color: color, mb: 2 }}>
              WORK EXPERIENCE
            </Typography>

            {[
              {
                title: "Senior Marketing Manager",
                comp: "Borcelle Studio | 2030 - Present",
                points: [
                  "Increased website traffic by 150% through SEO strategies.",
                  "Managed a team of 12 marketing professionals successfully.",
                  "Developed award-winning social media campaigns."
                ]
              },
              {
                title: "Marketing Specialist",
                comp: "Fauget Studio | 2025 - 2029",
                points: [
                  "Designed and executed 20+ email marketing campaigns.",
                  "Analyzed consumer data to optimize product positioning.",
                  "Coordinated international product launch events."
                ]
              }
            ].map((exp, i) => (
              <Box key={i} sx={{ mb: 3 }}>
                <Typography sx={{ fontWeight: "bold", fontSize: "16px", color: "#333" }}>{exp.title}</Typography>
                <Typography sx={{ fontSize: "13px", color: color, fontWeight: "600", mb: 1 }}>{exp.comp}</Typography>
                <ul style={{ margin: 0, paddingLeft: '18px', fontSize: fontSize, color: "#555" }}>
                  {exp.points.map((p, idx) => <li key={idx} style={{ marginBottom: '5px' }}>{p}</li>)}
                </ul>
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Right Column (Skills & Extra Info) */}
        <Grid item xs={5} sx={{width:"320px"}}>
          <Paper elevation={0} sx={{ p: 3, bgcolor: "#fcfcfc", border: "1px solid #f0f0f0", borderRadius: '8px' }}>
            <Typography sx={{ fontSize: headingSize, fontWeight: "bold", color: color, mb: 2 }}>
              CORE SKILLS
            </Typography>
            <Grid container spacing={1}>
              {["Marketing Strategy", "Data Analysis", "Public Relations", "Content Creation", "SEO/SEM", "Project Management"].map(skill => (
                <Grid item xs={12} key={skill}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Box sx={{ width: 8, height: 8, bgcolor: color, borderRadius: '50%', mr: 1.5 }} />
                    <Typography sx={{ fontSize: "13px" }}>{skill}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Typography sx={{ fontSize: headingSize, fontWeight: "bold", color: color, mb: 2 }}>
              EDUCATION
            </Typography>
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>Master of Business</Typography>
              <Typography sx={{ fontSize: "12px", color: "#666" }}>Wardiere University (2029-2030)</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>Bachelor of Commerce</Typography>
              <Typography sx={{ fontSize: "12px", color: "#666" }}>Wardiere University (2025-2029)</Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography sx={{ fontSize: headingSize, fontWeight: "bold", color: color, mb: 2 }}>
              LANGUAGES
            </Typography>
            <Typography sx={{ fontSize: "13px", mb: 0.5 }}>• English (Native)</Typography>
            <Typography sx={{ fontSize: "13px" }}>• Spanish (Professional)</Typography>
          </Paper>
        </Grid>
      </Grid>

    
    </Box>
  );
};

export default Resume32;
export const resumeMeta = {
  hasPhoto: false,
  columns: 2,
  colorOptions: [
    { value: '#2196f3', label: 'Blue' },
    { value: '#4caf50', label: 'Green' },
    { value: '#ff9800', label: 'Orange' },
    { value: '#9c27b0', label: 'Purple' },
    { value: '#f44336', label: 'Red' }
  ]
};